import React from 'react';
import './index.css';
import './modules/content-marketing/components/styles/globals.css';
import App from './App';
import { createRoot } from 'react-dom/client';
import * as serviceWorker from './serviceWorker';
import AuthenticationProvider from './modules/auth/services/auth.provider';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';


const rootElement = document.getElementById('root')!;
const root = createRoot(rootElement);
const queryClient = new QueryClient();

root.render(
  <AuthenticationProvider>
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <App />
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </React.StrictMode>
  </AuthenticationProvider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

// Hot Module Replacement
declare let module: { hot: any };

if (module.hot) {
  module.hot.accept('./App', () => {
    const NewApp = require('./App').default;

    root.render(
      <AuthenticationProvider>
        <React.StrictMode>
          <QueryClientProvider client={queryClient}>
            <NewApp />
            <ReactQueryDevtools initialIsOpen={false} />
          </QueryClientProvider>
        </React.StrictMode>
      </AuthenticationProvider>
    );
  });
}
